import { User } from './user';
import { Equipment } from './equipment';
import { Company } from './company';
import { ExternalResource } from './externalResource';
import { Product } from './product';
import { Container } from './container';

export enum EquipmentActivityProductMixUnits {
  KG = 'kg',
  LT = 'lt',
  UNIT = 'unit',
}

export class EquipmentActivityProductMix {
  uuid?: string = null;
  product: Product = null;
  dose: number = null;
  doseUnit: EquipmentActivityProductMixUnits = null;
  adversity: string = null;
  container: Container = null;
}

export class EquipmentActivity {
  id = null;
  type: string;
  tractorHours: number;
  description: string;
  materials: string;
  effortHours: number;
  effortMinutes: number;
  cost: number;
  activityDate: Date; // format yyyy-MM-dd (ex. "2017-08-05)
  dateCreated: Date;
  lastUpdated: Date;
  equipment: Equipment;
  people: Array<User>;
  companyId: any;
  supplier: Company;
  externalResources?: Array<ExternalResource> = [];
  mixes: EquipmentActivityProductMix[] = [];
  treatedVolume: number;
  waterVolumeUsed: number;
  controlOutcome: string;

  constructor() {
    this.id = null;
    this.type = null;
    this.equipment = null;
    this.tractorHours = null;
    this.description = null;
    this.materials = null;
    this.effortHours = null;
    this.effortMinutes = null;
    this.cost = null;
    this.activityDate = null; // format yyyy-MM-dd (ex. "2017-08-05)
    this.dateCreated = null;
    this.lastUpdated = null;
    this.people = null;
    this.companyId = null;
    this.supplier = null;
    this.externalResources = null;
    this.mixes = [];
    this.treatedVolume = null;
    this.waterVolumeUsed = null;
    this.controlOutcome = null;
  }
}
/*
*********** MODELLO DI BACKEND **********************

package com.xfarm.api.v1.core

import com.xfarm.api.v1.auth.User
import grails.databinding.BindingFormat

class EquipmentActivity {

    transient springSecurityService

    Long    companyId = -1
    string  type
    @BindingFormat('yyyy-MM-dd')
    Date    activityDate
    Integer tractorHours
    string  description
    string  materials
    Integer effortHours
    Double  cost
    Date    dateCreated
    Date    lastUpdated

    static hasMany = [people: User]
    static belongsTo = [equipment: Equipment]

    static mapping = {
        autoTimestamp true
    }

    static constraints = {
        companyId       blank: false
        type            blank: false, nullable: false, inList: ["annual", "incident", "usage"]
        activityDate    blank: false, nullable: true
        tractorHours    blank: false, nullable: true
        description     blank: false, nullable: true
        materials       blank: false, nullable: true
        effortHours     blank: false, nullable: true
        cost            blank: false, nullable: true


    }

    def beforeInsert() {
        companyId = User.get(springSecurityService?.principal?.id)?.farm?.id
    }

    def beforeUpdate() {
        if(companyId != User.get(springSecurityService?.principal?.id)?.farm?.id){
            return false
        }
    }

    static transients = ['springSecurityService']
}

*/
